import { render, staticRenderFns } from "./PolicyPrismic.vue?vue&type=template&id=a0ef5f44&"
import script from "./PolicyPrismic.vue?vue&type=script&lang=js&"
export * from "./PolicyPrismic.vue?vue&type=script&lang=js&"
import style0 from "./PolicyPrismic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports